module.exports = __webpack_public_path__ + "img/uob.756ea0e6.svg";